import React, { PureComponent } from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import { canUseWindow } from '@library/environment'

import { SocialIconButton } from '../SocialButton'
import {
  getFacebookReferralLink,
  getMessengerReferralLink,
  SOCIAL_TYPES,
} from '../socialReferralHelper'

import css from './SocialIconShareButtons.css'

const propTypes = {
  referralCode: PropTypes.string.isRequired,
  userFirstName: PropTypes.string.isRequired,
  device: PropTypes.string.isRequired,
  elementType: PropTypes.string,
  trackingReferFriendSocialSharing: PropTypes.func.isRequired,
  trackUserFreeFoodLinkShare: PropTypes.func.isRequired,
}

const defaultProps = {
  elementType: 'page',
}
class SocialIconShareButtons extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isGoustoFacebookInitiated: false,
    }
  }

  componentDidMount() {
    this.checkGoustoFacebookInitiated()
    window.addEventListener('GoustoFacebookInit', this.checkGoustoFacebookInitiated)
  }

  componentWillUnmount() {
    window.removeEventListener('GoustoFacebookInit', this.checkGoustoFacebookInitiated)
  }

  handleGetMessengerReferralLink = () => {
    const {
      referralCode,
      userFirstName,
      trackingReferFriendSocialSharing,
      device,
      trackUserFreeFoodLinkShare,
    } = this.props

    getMessengerReferralLink(
      referralCode,
      userFirstName,
      trackingReferFriendSocialSharing,
      device,
      trackUserFreeFoodLinkShare,
    )
  }

  handleGetFacebookReferralLink = () => {
    const {
      referralCode,
      userFirstName,
      trackingReferFriendSocialSharing,
      trackUserFreeFoodLinkShare,
    } = this.props

    getFacebookReferralLink(
      referralCode,
      userFirstName,
      trackingReferFriendSocialSharing,
      trackUserFreeFoodLinkShare,
    )
  }

  checkGoustoFacebookInitiated = () => {
    if (canUseWindow && window.FB) {
      this.setState({ isGoustoFacebookInitiated: true })
    }
  }

  render() {
    const { elementType } = this.props
    const socialShareButtonsClasses = classnames(
      css.mobileHide,
      css.socialButtons,
      {
        [css.pageSocialButtons]: elementType === 'page',
        [css.componentSocialButtons]: elementType === 'component'
      })

    const { isGoustoFacebookInitiated } = this.state

    if (!isGoustoFacebookInitiated) {
      return null
    }

    return (
      <section className={socialShareButtonsClasses}>
        <SocialIconButton
          data-testing="freeFoodMessengerCTA"
          text={SOCIAL_TYPES.messenger}
          type="facebook-messenger"
          elementType={elementType}
          onClick={this.handleGetMessengerReferralLink}
        />
        <SocialIconButton
          data-testing="freeFoodFacebookCTA"
          text={SOCIAL_TYPES.facebook}
          type="facebook"
          elementType={elementType}
          onClick={this.handleGetFacebookReferralLink}
        />
      </section>
    )
  }
}

SocialIconShareButtons.propTypes = propTypes
SocialIconShareButtons.defaultProps = defaultProps

export { SocialIconShareButtons, SOCIAL_TYPES }
